export default "__VITE_ASSET__EuFei1z6__"